@let state = $state();
<cm-asset-grid-cell>
    <cm-asset-cell-chip cm-top-left>Shaderball</cm-asset-cell-chip>

    <div cm-top-right class="cm-actions-slot">
        @switch (state.kind) {
            @case ("empty") {
                @if ($canEdit() && $hasCyclesMaterial()) {
                    <cm-asset-cell-chip interactive (click)="render.emit()"><i class="far fa-play"></i> Generate</cm-asset-cell-chip>
                }
            }
            @case ("loading") {
                @if ($canEdit()) {
                    <cm-asset-cell-chip interactive (click)="cancel.emit()"><cm-loading-spinner-icon></cm-loading-spinner-icon> Cancel</cm-asset-cell-chip>
                }
            }
            @case ("failed") {
                @if ($canEdit()) {
                    <cm-asset-cell-chip interactive (click)="retry.emit()"><i class="far fa-rotate-reverse"></i> Retry</cm-asset-cell-chip>
                    <cm-asset-cell-chip interactive (click)="remove.emit()"><i class="far fa-trash-can"></i></cm-asset-cell-chip>
                }
            }
            @case ("complete") {
                @if ($canDownload()) {
                    <cm-asset-cell-chip interactive [cdkMenuTriggerFor]="downloadMenu.menu()">
                        <i class="far fa-arrow-to-bottom"></i>
                    </cm-asset-cell-chip>
                    <cm-asset-download-menu #downloadMenu [dataObject]="state.result" />
                }
                @if ($canEdit()) {
                    <cm-asset-cell-chip interactive [cdkMenuTriggerFor]="actionsMenu.menu()">
                        <i class="far fa-ellipsis-v"></i>
                    </cm-asset-cell-chip>
                    <cm-asset-actions-menu #actionsMenu [actions]="actions" (action)="onAction($event)" />
                }
            }
        }
    </div>

    @if (state.kind === "complete") {
        <img
            class="cm-image cm-clickable"
            [src]="state.result.preview?.downloadUrl ?? state.result.jpeg?.downloadUrl ?? state.result.downloadUrl"
            alt=""
            (click)="preview.emit()"
        />
    } @else {
        <img class="cm-image" src="/assets/images/shaderball-placeholder.png" alt="" />
        @if (state.kind === "empty" && !$hasCyclesMaterial()) {
            <div class="cm-empty-overlay">
                <span class="cm-empty-message">Please create a material to generate outputs.</span>
            </div>
        }
    }
</cm-asset-grid-cell>
